"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file @preserve */
/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  CancelLabel: 'Cancel',
  ConfirmationLabel: 'Log out',
  DialogQuestion: 'You have items in the basket, do you want to log out and leave shopping anyway?',
  DialogTitle: 'Log out'
};
const translationsNamespace = exports.translationsNamespace = 'logout-confirm-dialog';
